import { SOURCES } from "./constants";

export default function SourcesSection() {
    return (
        <section className="py-12 bg-[#F7F5F0]">
            <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-14">
                <p className="text-[12px] uppercase tracking-[0.2em] text-[#C8A24A] font-medium mb-4">
                    We accept referrals from
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
                    {SOURCES.map((s) => (
                        <div
                            key={s.label}
                            className="bg-white rounded-2xl border border-[#E5DFD3] p-4 text-center"
                            data-testid={`source-${s.label.toLowerCase().replace(/\s/g, "-")}`}
                        >
                            <div className="h-9 w-9 rounded-full bg-[#E8EFE8] grid place-items-center text-[#0E2A47] mx-auto mb-2">
                                <s.icon className="h-4.5 w-4.5" />
                            </div>
                            <p className="text-[12.5px] font-medium text-[#1A2230] leading-tight">
                                {s.label}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
